export const FIVE_MB_IN_BYTES = 5_000_000;
export const TEN_MB_IN_BYTES = 10_000_000;

const bytesToMegaBytes = (bytes: number) => {
  return bytes / (1000 * 1000);
};

export default bytesToMegaBytes;
